module.exports = __webpack_public_path__ + "static/iec-mark-b742a1aff622ae4742f2c7f4a5e355e1.png";